import { createApp } from "vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import "./assets/css/style.css"; // 自定义样式放在最后，避免被覆盖
import App from "./App.vue";
import router from "./router";
import pinia from "./stores";
import i18n from "./i18n";
// import { initVConsole } from "./utils/vconsole";

// 初始化 vConsole（手机调试工具）
// Initialize vConsole for mobile debugging
// initVConsole();

createApp(App).use(pinia).use(router).use(Antd).use(i18n).mount("#app");
